// src/services/frameworkService.ts

import { IFramework } from '../interfaces/framework';
import api from './api';

export interface CreateFrameworkData {
  nome: string;
  descricao: string;
  dominios: number[];
  empresaId: number;
}

export interface UpdateFrameworkData extends Omit<CreateFrameworkData, 'empresaId'> {
  id: number;
}

class FrameworkService {
  async getAll(): Promise<IFramework[]> {
    const response = await api.getFrameworks();
    return response.success ? (response.data as IFramework[]) : [];
  }

  async create(frameworkData: CreateFrameworkData): Promise<IFramework | null> {
    const { empresaId, ...rest } = frameworkData;
    const response = await api.createFramework({ ...rest, empresa_id: empresaId });
    return response.success ? (response.data as IFramework) : null;
  }

  async update(id: number, frameworkData: UpdateFrameworkData): Promise<IFramework | null> {
    const response = await api.updateFramework(id, { ...frameworkData, id });
    return response.success ? (response.data as IFramework) : null;
  }

  async delete(id: number): Promise<boolean> {
    const response = await api.deleteFramework(id);
    return response.success;
  }

  async getById(id: number): Promise<IFramework | null> {
    const response = await api.getFramework(id);
    return response.success ? (response.data as IFramework) : null;
  }

  // Associação de questionário a framework
  async associarQuestionario(frameworkId: number, questionarioId: number): Promise<boolean> {
    const response = await api.associarQuestionario(frameworkId, questionarioId);
    return response.success;
  }

  async desassociarQuestionario(frameworkId: number, questionarioId: number): Promise<boolean> {
    const response = await api.desassociarQuestionario(frameworkId, questionarioId);
    return response.success;
  }

  async getQuestionarios(frameworkId: number): Promise<any[]> {
    const response = await api.getQuestionariosFramework(frameworkId);
    return response.success ? (response.data as any[]) : [];
  }

  async getQuestionariosDisponiveis(frameworkId: number): Promise<any[]> {
    const response = await api.getQuestionariosDisponiveis(frameworkId);
    return response.success ? (response.data as any[]) : [];
  }

  // Validação de associação
  async validarAssociacao(frameworkId: number, questionarioId: number): Promise<boolean> {
    const response = await api.validarAssociacao(frameworkId, questionarioId);
    return response.success && response.data?.podeSerAssociado;
  }
}

export const frameworkService = new FrameworkService();
export {};